const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

export const formatFileSize = x => {
  let l = 0,
    n = parseInt(x, 10) || 0;
  while (n >= 1024 && ++l) {
    n = n / 1024;
  }
  return n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l];
};

const fileTypeAcceptedExtensions = {
  'XLS': ['.xls', '.xlsx'],
  'XLSX': ['.xlsx', '.xls']
}

export const resolveFileTypeAcceptedExtensions = fileType => {
  if (!fileType) {
    return '';
  }
  return fileTypeAcceptedExtensions[fileType]?.join(', ') ?? `.${fileType.toLowerCase()}`;
};
